import { IFiniteStateMachine } from 'components/general/types/cdh';
import { Handle, NodeProps, Position, useReactFlow } from 'react-flow-renderer';
import { useRoutineState } from '..';
import useStyles from './styles';

const FiniteStateMachineNode = (props: NodeProps) => {
  const {
    id,
    dragging,
    isConnectable,
    data: { isSelected },
  } = props;
  const { setNodes } = useReactFlow();
  const { data } = useRoutineState<IFiniteStateMachine>(id);
  const { classes } = useStyles({
    selected: isSelected,
    dragging: dragging,
    isConnectable: isConnectable,
  });

  if (!data) return null;

  if (data.type !== 'FiniteStateMachine')
    setNodes((nodes) => {
      const newNodes = nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            type: data.type,
          };
        }
        return node;
      });
      return newNodes;
    });

  return (
    <div className={classes.finiteStateMachine}>
      {!isSelected && (
        <Handle type="target" id="target" position={Position.Top} isConnectable={isConnectable} />
      )}
      <div>
        <h3>{data.name}</h3>
      </div>
      {!isSelected && (
        <Handle
          type="source"
          id="source"
          position={Position.Bottom}
          isConnectable={isConnectable}
        />
      )}
    </div>
  );
};

export default FiniteStateMachineNode;
